export const categories = [
  {
    slug: "video-script",
    name: "视频脚本",
    description: "专业的视频脚本策划与撰写，涵盖各类视频类型的脚本模板与创意方案",
    icon: "ri-file-text-line",
    articleCount: 28,
    imageSeq: "cat-video-script",
  },
  {
    slug: "material-organize",
    name: "素材整理",
    description: "高效的视频素材管理与分类工具，让海量素材井井有条",
    icon: "ri-folder-5-line",
    articleCount: 19,
    imageSeq: "cat-material-organize",
  },
  {
    slug: "post-production",
    name: "后期制作",
    description: "视频后期处理全流程指南，从剪辑到特效一站式解决方案",
    icon: "ri-film-line",
    articleCount: 24,
    imageSeq: "cat-post-production",
  },
  {
    slug: "commercial-video",
    name: "商业视频",
    description: "面向企业品牌的商业视频创作方案，助力营销转化与品牌传播",
    icon: "ri-building-2-line",
    articleCount: 16,
    imageSeq: "cat-commercial-video",
  },
  {
    slug: "short-video",
    name: "短视频",
    description: "短视频平台内容创作技巧，抓住流量密码快速出圈",
    icon: "ri-smartphone-line",
    articleCount: 32,
    imageSeq: "cat-short-video",
  },
  {
    slug: "creative-planning",
    name: "创意策划",
    description: "视频创意头脑风暴与策划方法论，让你的内容脱颖而出",
    icon: "ri-lightbulb-line",
    articleCount: 21,
    imageSeq: "cat-creative-planning",
  },
];